import "./style.scss";
import warningModalIcon from "../../assets/images/warning_modal.svg";
import { Button } from "antd";
import { useMemo, useState } from "react";
import { country as countryList } from "../../utilities/country";

const CountryWarningModal = ({
  isOpen,
  text,
  onOK,
  loader,
  confirmText = "Please confirm your country",
}) => {
  const [country, setCountry] = useState("");
  const [step, setStep] = useState("form");

  // Country is a fixed list, unlike the free-text city - picking from it keeps
  // the saved value matching what the profile form expects.
  const countryOptions = useMemo(
    () => countryList.map((item) => item.country),
    []
  );

  if (!isOpen) return null;

  const handleSubmit = () => {
    setStep("confirm");
  };

  const handleConfirm = () => {
    onOK(country.trim());
  };

  const handleCancel = () => {
    setStep("form");
  };

  return (
    <div className="warning-modal-overlay">
      <div className="warning_modal_wrapper">
        <div className="warning_modal_container_top">
          <div className="warning_icon">
            <img src={warningModalIcon} alt="warningModalIcon" />
          </div>
        </div>

        <div
          className="warning-modal-container"
          onClick={(e) => e?.stopPropagation()}
        >
          <div className="warning_modal_container_bottom">
            <h1>Action Required!</h1>

            {step === "form" && (
              <>
                <div className="warning_modal_content">
                  <p>{text}</p>
                  <select
                    required
                    name="country"
                    id="country"
                    className="customCountrySelect"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  >
                    <option value="" disabled>
                      Select your country
                    </option>
                    {countryOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="warning_modal_btn">
                  <Button disabled={!country} onClick={handleSubmit}>
                    Save and Continue
                  </Button>
                </div>
              </>
            )}

            {step === "confirm" && (
              <>
                <div className="warning_modal_content">
                  <p className="confirmText">{confirmText}</p>
                  <strong>{country}</strong>
                </div>

                <div className="warning_modal_btn">
                  <Button onClick={handleCancel}>Back</Button>

                  <Button loading={loader} onClick={handleConfirm}>
                    Yes, Confirm
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryWarningModal;
